class QuickbuyVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onOptionChange = this.onOptionChange.bind(this);
  }

  connectedCallback() {
    this.url = this.dataset.url;
    this.formId = this.dataset.productFormId;
    this.productId = this.dataset.productId;
    this.form = document.getElementById(this.formId);

    this.addEventListener('change', this.onOptionChange);
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.removeEventListener('change', this.onOptionChange);
  }

  async onOptionChange() {
    this.requestId = (this.requestId || 0) + 1;
    const requestId = this.requestId;
    this.abortController?.abort();
    this.abortController = new AbortController();
    this.setPendingState();
    this.clearRequestError();
    this.form?.setAttribute('aria-busy', 'true');

    const selectedOptions = this.selectedOptionValues;
    const params = `&option_values=${selectedOptions.join(',')}`;
    const fetchUrl = `${this.url}?section_id=card-product${params}`;

    try {
      const response = await fetch(fetchUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        signal: this.abortController.signal,
      });

      if (requestId !== this.requestId) return;
      if (!response.ok) throw new Error('Quick-buy variant request failed');

      const htmlText = await response.text();
      if (requestId !== this.requestId) return;

      const doc = new DOMParser().parseFromString(htmlText, 'text/html');
      const fetchedForms = doc.querySelectorAll('form[data-type="add-to-cart-form"]');
      const newForm = fetchedForms.length === 1 ? fetchedForms[0] : null;
      const newVariantInput = newForm?.querySelector('input[name="id"]');
      const addButtonUpdated = newForm?.querySelector('[name="add"]');

      if (!this.form || !newVariantInput || !addButtonUpdated) {
        throw new Error('Quick-buy variant response is incomplete');
      }

      const currentVariantInput = this.form.querySelector('input[name="id"]');
      if (!currentVariantInput) throw new Error('Quick-buy variant input is missing');

      currentVariantInput.value = newVariantInput.value;
      currentVariantInput.disabled = false;

      const newPrice = doc.querySelector('.price__container');
      const oldPrice = this.closest('.product-card-wrapper').querySelectorAll('.price__container');

      if (newPrice && oldPrice) {
        oldPrice.forEach((price) => {
          price.innerHTML = newPrice.innerHTML;
        });
      }

      this.clearRequestError();
      this.toggleAddButton(addButtonUpdated.hasAttribute('disabled'), window.variantStrings.soldOut);

      const newMedia = doc.querySelector('.card__media');
      const oldMedia = this.closest('.product-card-wrapper').querySelector('.card__media');

      if (newMedia && oldMedia) {
        oldMedia.innerHTML = newMedia.innerHTML;
      }
    } catch (error) {
      if (requestId !== this.requestId || error.name === 'AbortError') return;
      this.setPendingState();
      this.showRequestError();
    } finally {
      if (requestId === this.requestId) {
        this.form?.removeAttribute('aria-busy');
        this.abortController = undefined;
      }
    }
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  setPendingState() {
    this.form?.querySelector('input[name="id"]')?.setAttribute('disabled', 'disabled');
    this.toggleAddButton(true);
  }

  showRequestError() {
    const errorMessageWrapper = this.form?.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const errorMessage = errorMessageWrapper?.querySelector('.product-form__error-message');

    if (!errorMessageWrapper || !errorMessage) return;
    errorMessage.textContent = window.cartStrings?.error || window.variantStrings?.unavailable;
    errorMessageWrapper.hidden = false;
  }

  clearRequestError() {
    const errorMessageWrapper = this.form?.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    if (errorMessageWrapper) errorMessageWrapper.hidden = true;
  }

  toggleAddButton(disable = true, text) {
    const productForm = document.getElementById(this.formId);

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    const addButtonText = productForm.querySelector('[name="add"] .product-form__add-button-text');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }
}

if (!customElements.get('quickbuy-variant-selects')) {
  customElements.define('quickbuy-variant-selects', QuickbuyVariantSelects);
}
